import React from 'react'

export default function article() {
  return (
    <h1>article</h1>
  )
}
